import { Cell, CellType } from "generated/graphql";

export enum CellPreset {
  Custom,
  SSN,
  BMI,
  PacksPerDay,
}

// The initial state of the cell form is not a valid cell, so creating this more lenient variant to model it
export type CellFormState = Omit<Cell, "name" | "type" | "selectOptions" | "rank" | "id" | "systemName"> & {
  name?: string;
  type?: CellType;
  selectOptions: string[];
  rank?: number;
  id?: number;
  systemName?: string;
};

export type CellFormKeys =
  | "name"
  | "type"
  | "selectOptions"
  | "optional"
  | "default"
  | "key"
  | "exportExclude"
  | "systemName"
  | "description"
  | "analyticsExclude"
  | "validationConfig";
